import api from './api';

export async function getConsultants(params = {}) {
  const { data } = await api.get('/consultant-ledger/consultants', { params });
  return data;
}

export async function createConsultant(payload) {
  const { data } = await api.post('/consultant-ledger/consultants', payload);
  return data;
}

export async function updateConsultant(consultantId, payload) {
  const { data } = await api.put(`/consultant-ledger/consultants/${consultantId}`, payload);
  return data;
}

export async function archiveConsultant(consultantId, reason) {
  const { data } = await api.delete(`/consultant-ledger/consultants/${consultantId}`, {
    data: { reason },
  });
  return data;
}

export async function getConsultantLedgerSummary(params = {}) {
  const { data } = await api.get('/consultant-ledger/summary', { params });
  return data;
}

export async function getConsultantWiseLedger(params = {}) {
  const { data } = await api.get('/consultant-ledger/consultant-wise', { params });
  return data;
}

export async function getPatientWiseLedger(params = {}) {
  const { data } = await api.get('/consultant-ledger/patient-wise', { params });
  return data;
}

export async function createConsultantFeeRecord(payload) {
  const { data } = await api.post('/consultant-ledger/fees', payload);
  return data;
}

export async function addConsultantPayment(payload) {
  const { data } = await api.post('/consultant-ledger/payments', payload);
  return data;
}

export async function addConsultantAdjustment(payload) {
  const { data } = await api.post('/consultant-ledger/adjustments', payload);
  return data;
}

export async function searchPatients(query) {
  const { data } = await api.get('/patients/search', { params: { q: query } });
  return data;
}

export async function getInvoices() {
  const { data } = await api.get('/invoices');
  return data;
}
